import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Modal, Form, Input, Row, Col, Select, message, Spin } from 'antd'; // Divider, Space,Checkbox
import PropTypes from 'prop-types';
import UpdateConnectionPopup from './UpdateConnectionPopup';
import DeleteConnectionPopup from './DeleteConnectionPopup';
import { getTitle, getTriggerFiledforEntity, getCountryData, getAllUsersData, getCityData, getSeniorityLevelData, getStateData, getLeadsourceData } from '../../../Api/Services/CommonApiService'
import { FetchContactByAccount, massDeleteContact, massUpdateContact } from '../../../Api/Services/ContactApiService'
import { FetchAllAccount } from '../../../Api/Services/AccountApiService'
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Data from '../MassupdateJson/InLineEditFields.json'
import { ChangeOwnerIcon, SaveIcon, CancelIcon, DeleteIcon } from '../../../components/Icons/Icons';

const { Option } = Select;

const Popup = ({ updatePopup, setUpdatePopup, contactIDs, GetAll, popupType, assignOwner, action, setStates, pageType, successMessage }) => {
    const ApprovalMessage = "This record creation has triggered an approval process. The record will be available only after it has been reviewed and approved."
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const history = useHistory();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [fieldValue, setFieldValue] = useState(1)
    const [accountData, setAccountData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [users, setUsers] = useState([])
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const [field1, setField1] = useState()
    const [leadsource, setLeadSource] = useState([])
    const [allCountry, setAllCountry] = useState([])
    const [stateData, setStateData] = useState([])
    const [cityData, setCityData] = useState([])
    const [seniority, setSeniority] = useState([])
    const [contactData, setContactData] = useState([])
    const [editAttributes, setEditAttributes] = useState([])
    const [selectBoxes, setSelectBoxes] = useState([{ editedField: "title", editedValue: null }]);
    const [title, setTitle] = useState([])
    const [errorData, setErrorData] = useState([])
    const [tagType, setTagType] = useState("Add")
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [uiReady, setUiReady] = useState(false)
    const fieldsToValidate = ['primaryEmail', 'secondaryEmail', 'email', 'mobile', 'assitantContactNumber', 'phone', 'website'];
    const isValidEmail = (email) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    };
    const isValidPhoneNumber = (phoneNumber) => {
        const phonePattern = /^[0-9+-]+$/;
        return phonePattern.test(phoneNumber);
    };
    const isValidWebsite = (website) => {
        const websiteRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return websiteRegex.test(website);
    };
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const validateQuery = (query) => {
        if (!fieldsToValidate.includes(query.editedField)) {
            return true;
        }
        switch (query.editedField) {
            case 'primaryEmail':
            case 'secondaryEmail':
            case 'email':
                if (!isValidEmail(query.editedValue)) {
                    message.error(`Please enter a valid email address.`);
                    return false;
                }
                break;
            case 'mobile':
            case 'assitantContactNumber':
            case 'phone':
                if (!isValidPhoneNumber(query.editedValue)) {
                    message.error(`Invalid phone/mobile number`);
                    return false;
                }
                break;
            case 'website':
                if (!isValidWebsite(query.editedValue)) {
                    message.error(`Please enter a valid website url.`);
                    return false;
                }
                break;
            default:
                return false;
        }
        return true;
    };
    const validateQueryData = (queryData) => {
        return queryData.every(validateQuery);
    };
    function RequiredValidity(queryData) {
        for (let i = 0; i < queryData.length; i += 1) {
            const query = queryData[i];
            if (!query.editedField) {
                return { isValid: false, message: 'Incomplete field(s)' };
            }
            if (query.visible !== "No") {
                if (!(query.editedField === "tags" && tagType === "Clear") &&
                    (query.editedValue === undefined || query.editedValue === null || (typeof query.editedValue === 'string' && query.editedValue.trim() === ''))
                ) {
                    return { isValid: false, message: 'Incomplete field(s)' };
                }
            }
        }
        return { isValid: true };
    }
    const handleClose = () => {
        setUpdatePopup(false);
        if (pageType === "Listing") {
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (popupType !== "Delete") {
            // setStates({ selectedRowKeys: [] })
        }
    }
    const handleChange = (value) => {
        setFieldValue(value)
    }
    const getTitleData = async () => {
        try {
            const data = await getTitle()
            const options = data.map((option, i) => (
                <Option value={option.title} key={i}>
                    {option.title}
                </Option>));
            setTitle(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            const options = data.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option.account_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.account_name}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.account_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>));
            setAccountData(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            setUsers(data)
        } catch (error) {
            message.error(error)
        }
    }
    const getLeadsource = async () => {
        try {
            const data = await getLeadsourceData()
            setLeadSource(data)
        } catch (error) {
            message.error(error)
        }
    }
    const getSeniorityLevel = async () => {
        try {
            const data = await getSeniorityLevelData()
            const options = data.map((option, i) => (
                <Option value={option.seniorityLevelId} key={i}>
                    {option.seniorityLevel}
                </Option>));
            setSeniority(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const onSubmit = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const formData = {
            contactIds: contactIDs,
        }
        if (popupType === "Change Owner") {
            if (fieldValue === 1) {
                formData.leadOwner = field1;
            }
            const isAnyFieldUndefined = Object.values(formData).some(value => value === undefined);
            if (!isAnyFieldUndefined) {
                try {
                    const response = await massUpdateContact(formData)
                    if (response.status === 200) {
                        if (action === "SingleChangeOwner") {
                            if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                                setErrorData(response.data);
                                setIsModalVisible1(true);
                                dispatch(setEditCall(false))
                                loadingRef.current = false;
                                setDelteClick(false)
                            }
                            else {
                                const isAutomation = response.data[0].message === AutomationMessage;
                                const isApproval = response.data[0].message === ApprovalMessage;
                                dispatch(setEditCall(false))
                                if (isApproval) {
                                    successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                                } else if (isAutomation) {
                                    successMessage("Automation rule triggered", response.data[0].message);
                                } else {
                                    message.success(
                                        <span>
                                            Contact <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                        </span>
                                    );
                                }
                                loadingRef.current = false;
                                setDelteClick(false)
                                setUpdatePopup(false);
                                if (!isApproval && assignOwner !== field1) {
                                    history.push('/Home/contacts');
                                }
                                if (assignOwner === field1) {
                                    GetAll()
                                }
                            }
                        }
                        else {
                            const allUpdatedSuccessfully = response.data.every(item =>
                                item.message === "Contact Has Updated Successfully"
                            );
                            if (allUpdatedSuccessfully) {
                                dispatch(setEditCall(false))
                                if (pageType === "Listing") {
                                    setStates({
                                        selectedRows: [],
                                        selectedRowKeys: [],
                                    })
                                }
                                message.success("Data updated for selected records")
                                GetAll()
                                setUpdatePopup(false);
                                loadingRef.current = false;
                                setDelteClick(false)
                                return;
                            }
                            loadingRef.current = false;
                            setDelteClick(false)
                            dispatch(setEditCall(false))
                            setErrorData(response.data);
                            setIsModalVisible1(true);
                        }
                    }
                }
                catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    message.error(error)
                }
            } else {
                loadingRef.current = false;
                setDelteClick(false)
                message.error("Field is Empty");
            }
        }
        if (popupType === "Bulk Update") {
            const validation = RequiredValidity(selectBoxes);
            if (!validation.isValid) {
                message.error(validation.message);
                loadingRef.current = false;
                setDelteClick(false)
                return;
            }
            if (validateQueryData(selectBoxes)) {
                const flatFields = selectBoxes.reduce((acc, item) => {
                    const { editedField, editedValue, visible } = item;
                    if (!editedField) return acc;
                    if (editedField === "tags") {
                        acc[editedField] = tagType === "Clear" ? null : normalizeValue(editedValue);
                        acc.actionType = tagType;
                        return acc;
                    }
                    const normalizedValue = normalizeValue(editedValue);
                    if (visible === "No") {
                        acc[editedField] = normalizedValue;
                        return acc;
                    }
                    if (editedValue != null) {
                        acc[editedField] = normalizedValue;
                    }
                    return acc;
                }, {});
                Object.assign(formData, flatFields);
                try {
                    const response = await massUpdateContact(formData)
                    if (response.status === 200) {
                        const allUpdatedSuccessfully = response.data.every(item =>
                            item.message === "Contact Has Updated Successfully"
                        );
                        if (allUpdatedSuccessfully) {
                            dispatch(setEditCall(false))
                            if (pageType === "Listing") {
                                setStates({
                                    selectedRows: [],
                                    selectedRowKeys: [],
                                })
                            }
                            message.success("Data updated for selected records")
                            GetAll()
                            setUpdatePopup(false);
                            loadingRef.current = false;
                            setDelteClick(false)
                            return;
                        }
                        loadingRef.current = false;
                        setDelteClick(false)
                        dispatch(setEditCall(false))
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                    }
                } catch (error) {
                    loadingRef.current = false;
                    setDelteClick(false)
                    message.error(error)
                }
            }
        }
    }
    const HandleIsModalVisible = (value) => {
        setUpdatePopup(value)
        setIsModalVisible(value)
    }
    async function onDelete() {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        const payload = {
            contactIds: contactIDs
        }
        try {
            const response = await massDeleteContact(payload)
            if (response.status === 200) {
                if (popupType === "Delete") {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible(true);
                        dispatch(setEditCall(false))
                        loadingRef.current = false;
                        setDelteClick(false)
                    } else {
                        const isAutomation = response.data[0].entityMessage === AutomationMessage;
                        const isApproval = response.data[0].entityMessage === ApprovalMessage;
                        dispatch(setEditCall(false))
                        loadingRef.current = false;
                        setDelteClick(false)
                        if (isApproval) {
                            successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                        } else if (isAutomation) {
                            successMessage("Automation rule triggered", response.data[0].entityMessage);
                        } else {
                            message.success(
                                <span>
                                    Contact <strong>{response?.data?.[0]?.entityName}</strong> has been deleted successfully
                                </span>
                            );
                        }
                        history.push('/Home/contacts')
                        setUpdatePopup(false);
                    }
                } else {
                    const allUpdatedSuccessfully = response.data.every(item =>
                        item.entityMessage === "Contact Has Deleted Successfully"
                    );
                    if (allUpdatedSuccessfully) {
                        dispatch(setEditCall(false))
                        message.success(`${contactIDs.length} record${contactIDs.length > 1 ? "s" : ""} deleted successfully`);
                        GetAll();
                        setStates({
                            selectedRows: [],
                            selectedRowKeys: [],
                        })
                        setUpdatePopup(false);
                        loadingRef.current = false;
                        setDelteClick(false)
                        return;
                    }
                    loadingRef.current = false;
                    setDelteClick(false)
                    dispatch(setEditCall(false))
                    setErrorData(response.data);
                    setIsModalVisible(true);
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDelteClick(false)
            message.error(error)
        }
    }
    const getRefreshtheTable = () => {
        setUpdatePopup(false);
        if (pageType === "Listing") {
            GetAll();
            setStates({
                selectedRows: [],
                selectedRowKeys: [],
            })
        }
        if (popupType === "Delete") {
            history.push('/Home/contacts')
        }
    }
    const handleContactOwner = (value) => {
        setField1(value)
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            const options = response.map((option) => (
                <Option key={option.countryId} value={option.country}>
                    {option.country}
                </Option>))
            setAllCountry(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function Triggerfields() {
        try {
            const response = await getTriggerFiledforEntity("Contact")
            const removeFields = ["firstName", "lastName", "email"];
            const filteredAttributes = response?.filter((item) => item.filedValue !== "description").filter(
                item => !removeFields.includes(item.filedValue)
            );
            setEditAttributes(filteredAttributes)
        } catch (error) {
            message.error(error)
        }
    }
    // const getFieldIndex = (formData, fieldName) => {
    //     return formData.find(item => item.editedField === fieldName);
    // };
    const handleViewChange = async (index, fieldName, value, key, currecnyData, option) => {
        if (fieldName === "editedField" && value === "tags") {
            setTagType("Add")
        }
        let updatedFormData = [...selectBoxes];
        if (fieldName === "editedField") {
            const oldData = updatedFormData[index].editedField;
            if (oldData === "accountId") {
                updatedFormData = updatedFormData?.filter((item, idx) => {
                    if (idx === 0) return true;
                    return !["reportingTo"].includes(item.editedField);
                });
            }
            updatedFormData[index] = {
                ...updatedFormData[index],
                editedField: normalizeValue(value),
                editedValue: null,
                Key: key,
                Currency: currecnyData
            };
            if (normalizeValue(value) === "country" || normalizeValue(value) === "state" || normalizeValue(value) === "city" || normalizeValue(value) === "accountId" || normalizeValue(value) === "reportingTo" || normalizeValue(value) === "street" || normalizeValue(value) === "postcode") {
                const countryField = {
                    editedField: "country",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                const stateField = {
                    editedField: "state",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                const cityField = {
                    editedField: "city",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                const streetField = {
                    editedField: "street",
                    editedValue: null,
                    Key: null,
                    Currency: null
                };
                if (normalizeValue(value) === "country") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "accountId" && item.editedField !== 'reportingTo'
                    );
                    updatedFormData = updatedFormData.map(item =>
                        (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode")
                            ? {
                                ...item, editedField: item.editedField, editedValue: null
                            }
                            : item
                    );
                    setStateData([])
                    setCityData([])
                }
                if (normalizeValue(value) === "state") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== 'city' && item.editedField !== "street" && item.editedField !== "postcode" && item.editedField !== "accountId" && item.editedField !== "reportingTo"
                    );
                    updatedFormData.splice(index, 0, countryField);

                    setStateData([])
                    setCityData([])
                }
                if (normalizeValue(value) === "city") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "street" && item.editedField !== "postcode" && item.editedField !== "accountId" && item.editedField !== "reportingTo"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField);
                }
                if (normalizeValue(value) === "street") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "postcode" && item.editedField !== "accountId" && item.editedField !== "reportingTo"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField);
                }
                if (normalizeValue(value) === "postcode") {
                    setStateData([])
                    setCityData([])
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street" && item.editedField !== "accountId" && item.editedField !== "reportingTo"
                    );
                    updatedFormData.splice(index, 0, countryField, stateField, cityField, streetField);
                }
                if (normalizeValue(value) === "accountId") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    updatedFormData = updatedFormData.map(item =>
                        (item.editedField === "reportingTo")
                            ? {
                                ...item, editedField: item.editedField, editedValue: null
                            }
                            : item
                    );
                    setContactData([])
                }
                if (normalizeValue(value) === "reportingTo") {
                    updatedFormData = updatedFormData.filter(
                        item => item.editedField !== "country" && item.editedField !== "state" && item.editedField !== "city" && item.editedField !== "street" && item.editedField !== "postcode"
                    );
                    const hasCountry = updatedFormData.some(item => item.editedField === "accountId");
                    const inserts = [];
                    if (!hasCountry) {
                        inserts.push({
                            editedField: "accountId",
                            editedValue: null,
                            Key: null,
                            Currency: null
                        });
                    }
                    if (inserts.length > 0) {
                        updatedFormData.splice(index, 0, ...inserts);
                        index += inserts.length;
                    }
                }
            }
            else {
                updatedFormData = updatedFormData?.filter(
                    item => !["country", "state", "city", "street", "postcode", "accountId", "reportingTo"].includes(item.editedField)
                );
            }
        }
        else {
            const editedFieldType = updatedFormData[index]?.editedField;
            updatedFormData[index] = {
                ...updatedFormData[index],
                [fieldName]: value,
                Key: key
            };
            if (editedFieldType === "country") {
                try {
                    const response = await getStateData(option.key)
                    setStateData(response)
                    setCityData([])
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "state"
                    );
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "state") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "state",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "state" || item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    setStateData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "state") {
                try {
                    const response = await getCityData(option.key)
                    setCityData(response)
                    const existingIndex2 = updatedFormData.find(
                        item => item.editedField === "city"
                    );
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex2) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "city") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "city",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "city" || item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setCityData([])
                    message.error(error)
                }
            }
            else if (editedFieldType === "city") {
                try {
                    const existingIndex3 = updatedFormData.find(
                        item => item.editedField === "street"
                    );
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex3) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "street") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "street",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "street" || item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
            else if (editedFieldType === "street") {
                try {
                    const existingIndex4 = updatedFormData.find(
                        item => item.editedField === "postcode"
                    );
                    if (existingIndex4) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "postcode") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "postcode",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }
                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "postcode") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    message.error(error)
                }
            }
            else if (editedFieldType === "accountId") {
                try {
                    const response = await FetchContactByAccount(normalizeValue(value))
                    setContactData(response)
                    const existingIndex = updatedFormData.find(
                        item => item.editedField === "reportingTo"
                    );
                    if (existingIndex) {
                        updatedFormData = updatedFormData.map(item => {
                            if (item.editedField === "reportingTo") {
                                return {
                                    ...item,
                                    editedValue: null
                                };
                            }
                            return item;
                        });
                    }
                    else {
                        updatedFormData.push({
                            editedField: "reportingTo",
                            editedValue: null,
                            Key: null,
                            Currency: null,
                            visible: "No"
                        });
                    }

                }
                catch (error) {
                    updatedFormData = updatedFormData.map(item => {
                        if (item.editedField === "reportingTo") {
                            return {
                                ...item,
                                editedValue: null
                            };
                        }
                        return item;
                    });
                    setContactData([])
                    message.error(error)
                }
            }
        }
        setSelectBoxes(updatedFormData);
    };
    const getAvailableOptions = (currentIndex) => {
        const selectedValues = selectBoxes.filter(box => box.visible !== "No").map(box => box.editedField).filter(value => value !== undefined);
        return editAttributes.filter(option => !selectedValues.includes(option.filedValue) || selectBoxes[currentIndex].editedField === option.filedValue);
    };
    function getFieldTypeByValue(fieldValue) {
        const field = editAttributes.find(item => item.filedValue === fieldValue);
        return field ? field.FieldType : null;
    }


    const getUserDetail = async () => {
        if (action === "SingleChangeOwner") {
            setField1(assignOwner)
            form.setFieldsValue({
                leadOwner: assignOwner
            });
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if (profile.department === "Sales") {
                setField1(profile.userId)
                form.setFieldsValue({
                    leadOwner: profile.userId
                });
            }
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            getSeniorityLevel(),
            Triggerfields(),
            getTitleData(),
            getLeadsource(),
            UserDetailsApi(),
            getCountry(),
            AccountApi(),
            getUserDetail(),
        ])
        setUiReady(true)
    };
    const fetchAll1 = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            getUserDetail()
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (updatePopup) {
            if (popupType === "Bulk Update") {
                fetchAll()
            }
            else if (popupType === "Change Owner") {
                fetchAll1()
            }
            else {
                setUiReady(true)
            }
        }
    }, [updatePopup])
    const segBtn1 = (active) => ({ flex: 1, padding: "7px 0", fontSize: 12.5, fontWeight: 600, cursor: "pointer", borderRadius: 6, color: active ? "#407fe9" : "#8f8f8f", border: "none", background: active ? "white" : "transparent", });
    return (
        <>
            <Modal
                title={popupType}
                open={updatePopup}
                onCancel={handleClose}
                // centered
                maskClosable={false}
                footer={uiReady ? [
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 8, whiteSpace: 'nowrap' }}>
                        {popupType === "Bulk Update" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <CancelIcon />Cancel
                                </Button>
                                <Button className='btn-add_new button_colors' onClick={onSubmit} size="small" loading={deleteClick} disabled={deleteClick}>
                                    {!deleteClick && <SaveIcon />}Update
                                </Button>
                            </>
                        }
                        {popupType === "Change Owner" &&
                            <>
                                <Button onClick={handleClose} className="gray-button" size="small">
                                    <CancelIcon />Cancel
                                </Button>
                                <Button htmlType="submit" size="small" className='btn-add_new button_colors' onClick={onSubmit} loading={deleteClick} disabled={deleteClick}>
                                    {!deleteClick && <ChangeOwnerIcon />}Change Owner
                                </Button>
                            </>
                        }
                        {popupType.includes("Delete") &&
                            <>
                                <Button htmlType="submit" size="small" className="gray-button" onClick={handleClose}>
                                    <CancelIcon /> Cancel
                                </Button>
                                <Button htmlType="submit" size="small" onClick={onDelete} className='red-button' loading={deleteClick} disabled={deleteClick}>
                                    {!deleteClick && <DeleteIcon />}{popupType}
                                </Button>
                            </>}
                    </div>
                ] : false}
            // width={600}
            >  {uiReady ? <>
                {popupType === "Bulk Update" &&
                    (editAttributes.length > 0 ? <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="AccountMassUpdate">
                                    {selectBoxes.filter((item) => item?.visible !== "No").map((selectbox, index) => {
                                        const filedType = getFieldTypeByValue(selectbox.editedField)
                                        return (
                                            <>
                                                <div style={{ padding: "0px 20px", display: selectbox.editedField !== 'tags' && "none" }}>
                                                    <div style={{ display: "flex", gap: 4, background: "#f7f7f7", borderRadius: 8, padding: 5, marginBottom: "0px 0px 20px" }}>
                                                        <button type="button" style={segBtn1(tagType === "Add")} onClick={() => setTagType("Add")}>Add tag</button>
                                                        <button type="button" style={segBtn1(tagType === "Remove")} onClick={() => setTagType("Remove")}>Remove tag</button>
                                                        <button type="button" style={segBtn1(tagType === "Clear")} onClick={() => {
                                                            setTagType("Clear");
                                                            setSelectBoxes(prev =>
                                                                prev.map(item =>
                                                                    item.editedField === "tags"
                                                                        ? { ...item, editedValue: "" }
                                                                        : item
                                                                )
                                                            );
                                                        }}>Clear all</button>
                                                    </div>
                                                </div>
                                                <Row gutter={30} style={{ marginBottom: 20, marginTop: 20, padding: "0px 20px" }}>
                                                    <Col span={10}>
                                                        <Form.Item >
                                                            <Select style={{ width: '100%' }}
                                                                placeholder="Select Field"
                                                                showSearch
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                value={selectbox.editedField}
                                                                onChange={(record, option) => {
                                                                    const Key = option.FieldType
                                                                    const currecnyData = option.FieldData
                                                                    handleViewChange(index, 'editedField', record, Key, currecnyData);
                                                                }}
                                                                disabled={index !== 0}
                                                            >
                                                                {getAvailableOptions(index).map((option, idx) => (
                                                                    <Option value={option.filedValue} key={idx} FieldType={option.FieldType} FieldData={option.currencyType}>
                                                                        {option.fieldLable}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={14}>
                                                        <Form.Item key={index}>
                                                            {selectbox.editedField === 'tags' ?
                                                                <Select open={false}
                                                                    className="lead-tags-input"
                                                                    mode="tags" disabled={tagType === "Clear"}
                                                                    style={{ width: "100%" }}
                                                                    placeholder="Enter tags"
                                                                    tokenSeparators={[","]}
                                                                    value={selectbox.editedValue ? selectbox.editedValue.split(",").map((tag) => tag.trim()).filter(Boolean) : []}
                                                                    onChange={(value, option) => {
                                                                        handleViewChange(index, 'editedValue', value?.join(",") || "", filedType, selectbox.Currency, option);
                                                                    }}
                                                                />
                                                                : filedType === 'Drop Down' ? (
                                                                    <Select placeholder="Select Value"
                                                                        showSearch
                                                                        style={{ width: "100%" }}
                                                                        optionFilterProp="children"
                                                                        {...(selectbox.editedField === "leadOwner" || selectbox.editedField === "accountId" || selectbox.editedField === "reportingTo"
                                                                            ? { optionLabelProp: "label" } : {})}
                                                                        filterOption={(input, option) =>
                                                                            (selectbox.editedField === "leadOwner" || selectbox.editedField === "accountId" || selectbox.editedField === "reportingTo")
                                                                                ? (() => {
                                                                                    const usernameElement = option.children.props.children[1].props.children[0];
                                                                                    if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                        const username = String(usernameElement.props.children);
                                                                                        return username.toLowerCase().includes(input.toLowerCase());
                                                                                    }
                                                                                    return false;
                                                                                })()
                                                                                : option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        name="editedValue"
                                                                        value={selectbox.editedValue}
                                                                        onChange={(value, option) => {
                                                                            handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency, option);
                                                                        }}
                                                                    >
                                                                        {(selectbox.editedField === "leadOwner") &&
                                                                            users?.filter(item => item.department === "Sales").map((option, i) => (
                                                                                <Option value={option.userId}
                                                                                    label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                            <div className='Div_flex2'>
                                                                                                <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                                    {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                        < img src={option.profilePic} alt="profile" />
                                                                                                        :
                                                                                                        <span className="image_icon UserIcon">
                                                                                                            {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                        </span>
                                                                                                    }
                                                                                                    <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    )}
                                                                                    key={i}>
                                                                                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                                        <div>
                                                                                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }</div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                            <p style={{ margin: 0 }}>{option.username}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))
                                                                        }
                                                                        {(selectbox.editedField === "emailOtpOut" || selectbox.editedField === "emailOptOut") && <>
                                                                            <Option value>Yes</Option>
                                                                            <Option value={false}>No</Option>
                                                                        </>}
                                                                        {selectbox.editedField === "seniorityLevelId" && <>
                                                                            {seniority}
                                                                        </>}
                                                                        {selectbox.editedField === "accountId" && <>
                                                                            {accountData}
                                                                        </>}
                                                                        {selectbox.editedField === "reportingTo" && <>
                                                                            {contactData.map((option, i) => (
                                                                                <Option value={option.contacts_id} key={i}
                                                                                    label={(
                                                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                            <div className='Div_flex2'>
                                                                                                <div className='share_image' title={`${option.first_name} ${option.last_name} (${option.email})`} style={{ cursor: "default" }}>
                                                                                                    {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                                        < img src={option.contact_profile} alt="profile" />
                                                                                                        :
                                                                                                        <span className="image_icon ContactIcon">
                                                                                                            {option.first_name.slice(0, 1).toUpperCase()}
                                                                                                        </span>
                                                                                                    }
                                                                                                    <span className='div-ellipsis'>{`${option.first_name} ${option.last_name}`}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>)} >
                                                                                    <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                                                                                        <div>
                                                                                            {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                                                                                < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option.first_name.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }</div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                                                                            <p style={{ margin: 0 }}>{option.email}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))}
                                                                        </>}
                                                                        {selectbox.editedField === "title" && <>
                                                                            {title}
                                                                        </>}
                                                                        {(selectbox.editedField === "contactSourceId") &&
                                                                            leadsource.map((option) => (
                                                                                <Option value={option.leadSourceId} key={option.id}>
                                                                                    {option.leadSourceName}
                                                                                </Option>))}

                                                                        {selectbox.editedField === "country" &&
                                                                            <>
                                                                                {allCountry}
                                                                            </>}
                                                                        {selectbox.editedField === "state" &&
                                                                            <>
                                                                                {stateData?.map((option) => (
                                                                                    <Option key={option.stateId} value={option.state}>
                                                                                        {option.state}
                                                                                    </Option>
                                                                                ))}
                                                                            </>}
                                                                        {selectbox.editedField === "city" &&
                                                                            <>
                                                                                {cityData?.map((option) => (
                                                                                    <Option key={option.cityId} value={option.city}>
                                                                                        {option.city}
                                                                                    </Option>
                                                                                ))}
                                                                            </>}
                                                                    </Select>
                                                                ) : filedType === 'Boolean' ?
                                                                    <Select placeholder="Select Value"
                                                                        showSearch
                                                                        style={{ width: "100%" }}
                                                                        optionFilterProp="children"
                                                                        name="editedValue"
                                                                        value={selectbox.editedValue}
                                                                        onChange={(value) => {
                                                                            handleViewChange(index, 'editedValue', value, filedType, selectbox.Currency);
                                                                        }}
                                                                    >
                                                                        {(selectbox.editedField === "resell" || selectbox.editedField === "emailOtpOut" || selectbox.editedField === "emailOptOut") && <>
                                                                            <Option value>Yes</Option>
                                                                            <Option value={false}>No</Option>
                                                                        </>}
                                                                    </Select>
                                                                    : filedType === 'Free Text' || filedType === 'Numbers' ? (
                                                                        (<Input placeholder="Enter Value" style={{ width: "100%" }}
                                                                            name="editedValue"
                                                                            value={selectbox.editedValue}
                                                                            onChange={(e) => {
                                                                                const inputValue = e.target.value;
                                                                                const TotalLength = selectbox.editedField  === "street" ? 100 : 50
                                                                                if (inputValue?.toString()?.length > TotalLength) {
                                                                                    message.error(`Maximum ${TotalLength} characters allowed`);
                                                                                    return;
                                                                                }
                                                                                handleViewChange(index, 'editedValue', inputValue, filedType, selectbox.Currency);
                                                                            }} />
                                                                        ))
                                                                        : ""
                                                            }
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </>
                                        )
                                    })}
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser> :
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "120px" }}>
                            <Spin />
                        </div>)
                }
                {popupType === "Change Owner" &&
                    <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <Form style={{ width: '100%' }} form={form} name="Assignto" >

                                    <Row gutter={30} style={{ marginBottom: 20, marginTop: 20 }}>
                                        <Col span={10}>
                                            <Form.Item>
                                                <Select style={{ width: '100%' }}
                                                    placeholder="Select Field"
                                                    showSearch
                                                    disabled
                                                    optionFilterProp="children"
                                                    filterOption={(input, option) =>
                                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    value={fieldValue}
                                                    onChange={handleChange}
                                                >
                                                    {Data.Contacts !== undefined && Data.Contacts?.map((option, key) => (
                                                        <Option key={key} value={option.id}>
                                                            {option.filed}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={14}>
                                            {fieldValue === 1 &&
                                                <Form.Item name="leadOwner" id="leadOwner">
                                                    <Select style={{ width: '100%' }}
                                                        placeholder="Select Contact Owner"
                                                        showSearch
                                                        optionLabelProp="label"
                                                        filterOption={(input, option) => {
                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                const username = String(usernameElement.props.children);
                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                            }
                                                            return false;
                                                        }
                                                        }
                                                        onChange={handleContactOwner}
                                                    >
                                                        {users.filter(item => item.department === "Sales").map((option, i) => (
                                                            <Option value={option.userId}
                                                                label={(
                                                                    <div style={{ display: 'flex', alignItems: 'center' }} title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                        <div className='Div_flex2'>
                                                                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                                                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                    < img src={option.profilePic} alt="profile" />
                                                                                    :
                                                                                    <span className="image_icon UserIcon">
                                                                                        {option.firstName.slice(0, 1).toUpperCase()}
                                                                                    </span>
                                                                                }
                                                                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                key={i}>
                                                                <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                    <div>
                                                                        {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                            < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                            :
                                                                            <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                {option.firstName.slice(0, 1).toUpperCase()}
                                                                            </span>
                                                                        }</div>
                                                                    <div>
                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                        <p style={{ margin: 0 }}>{option.username}</p>
                                                                    </div>
                                                                </div>
                                                            </Option>))}
                                                    </Select>
                                                </Form.Item>}
                                        </Col>
                                    </Row>
                                </Form>
                            </BasicFormWrapper>
                        </div>
                    </AddUser>
                }
                {popupType.includes("Delete") &&
                    < div >
                        <div className='d-flex align-items-start justify-content-center' style={{ fontSize: 15 }}>
                            {popupType === "Bulk Delete" && <p>Are you sure you want to delete the selected contacts?</p>}
                            {popupType === "Delete" && <p>Are you sure you want to delete?</p>}
                        </div>
                    </div>
                } </> :
                <div className="spin" style={{ height: "250px" }}>
                    <Spin />
                </div>}
            </Modal >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page={pageType === "Listing" ? "DetailsError" : "Details"} type="Contact" getCallBack={getRefreshtheTable} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page={popupType === "Bulk Delete" ? "DetailsError" : "Details"} type="Contact" getCallBack={getRefreshtheTable} />}
        </>
    );
};

Popup.propTypes = {
    updatePopup: PropTypes.bool.isRequired,
    setUpdatePopup: PropTypes.func.isRequired,
    contactIDs: PropTypes.array.isRequired,
    GetAll: PropTypes.func.isRequired,
    setStates: PropTypes.func.isRequired,
    popupType: PropTypes.string.isRequired,
    pageType: PropTypes.string.isRequired,
    action: PropTypes.string.isRequired,
    assignOwner: PropTypes.number.isRequired,
    successMessage: PropTypes.func.isRequired,
};

export default Popup;